var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { width: "1000" },
      model: {
        value: _vm.dialog,
        callback: function($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c("EditarHorarioEspecial"),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            { staticClass: "headline" },
            [
              _c("v-icon", [_vm._v("event_note")]),
              _vm._v("\n      Ver horarios especiales\n      "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { icon: "" },
                  on: {
                    click: function($event) {
                      return _vm.close()
                    }
                  }
                },
                [_c("v-icon", [_vm._v("clear")])],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-text",
            [
              _c("v-data-table", {
                staticClass: "elevation-1",
                attrs: {
                  headers: _vm.headers,
                  items: _vm.lista_horarios_especiales,
                  "disable-initial-sort": true
                },
                scopedSlots: _vm._u([
                  {
                    key: "items",
                    fn: function(props) {
                      return [
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(props.item.fecha_creacion) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(props.item.descripcion) +
                              " -" +
                              _vm._s(props.item.detalle) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(props.item.tipo_horario) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          [
                            _c(
                              "v-edit-dialog",
                              {
                                attrs: {
                                  "return-value": props.item.fecha_desde,
                                  lazy: ""
                                },
                                on: {
                                  "update:returnValue": function($event) {
                                    return _vm.$set(
                                      props.item,
                                      "fecha_desde",
                                      $event
                                    )
                                  },
                                  "update:return-value": function($event) {
                                    return _vm.$set(
                                      props.item,
                                      "fecha_desde",
                                      $event
                                    )
                                  },
                                  save: function($event) {
                                    return _vm.save(props.item)
                                  },
                                  cancel: _vm.cancel_horario_esp,
                                  open: _vm.open_horario_esp,
                                  close: _vm.close_horario_esp
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "input",
                                      fn: function() {
                                        return [
                                          _c("v-text-field", {
                                            attrs: {
                                              type: "date",
                                              rules: [
                                                function(v) {
                                                  if (
                                                    v > props.item.fecha_hasta
                                                  ) {
                                                    return (
                                                      "Introduzcca una fecha menor o igual a " +
                                                      props.item.fecha_hasta
                                                    )
                                                  }
                                                  return true
                                                }
                                              ],
                                              label: "",
                                              "single-line": "",
                                              autofocus: ""
                                            },
                                            model: {
                                              value: props.item.fecha_desde,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  props.item,
                                                  "fecha_desde",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "props.item.fecha_desde"
                                            }
                                          })
                                        ]
                                      },
                                      proxy: true
                                    }
                                  ],
                                  null,
                                  true
                                )
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(props.item.fecha_desde) +
                                    "\n              "
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          [
                            _c(
                              "v-edit-dialog",
                              {
                                attrs: {
                                  "return-value": props.item.fecha_hasta,
                                  lazy: ""
                                },
                                on: {
                                  "update:returnValue": function($event) {
                                    return _vm.$set(
                                      props.item,
                                      "fecha_hasta",
                                      $event
                                    )
                                  },
                                  "update:return-value": function($event) {
                                    return _vm.$set(
                                      props.item,
                                      "fecha_hasta",
                                      $event
                                    )
                                  },
                                  save: function($event) {
                                    return _vm.save(props.item)
                                  },
                                  cancel: _vm.cancel_horario_esp,
                                  open: _vm.open_horario_esp,
                                  close: _vm.close_horario_esp
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "input",
                                      fn: function() {
                                        return [
                                          _c("v-text-field", {
                                            attrs: {
                                              type: "date",
                                              label: "",
                                              "single-line": "",
                                              autofocus: ""
                                            },
                                            model: {
                                              value: props.item.fecha_hasta,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  props.item,
                                                  "fecha_hasta",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "props.item.fecha_hasta"
                                            }
                                          })
                                        ]
                                      },
                                      proxy: true
                                    }
                                  ],
                                  null,
                                  true
                                )
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(props.item.fecha_hasta) +
                                    "\n              "
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(props.item.estado) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticClass: "text-xs-center" },
                          [
                            _c(
                              "v-tooltip",
                              { attrs: { bottom: "" } },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      slot: "activator",
                                      color: "red",
                                      dark: "",
                                      icon: ""
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.eliminarHorarioEspecial(
                                          props.item
                                        )
                                      }
                                    },
                                    slot: "activator"
                                  },
                                  [_c("v-icon", [_vm._v("delete")])],
                                  1
                                ),
                                _vm._v(" "),
                                _c("span", [_vm._v("Eliminar")])
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-tooltip",
                              { attrs: { bottom: "" } },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      slot: "activator",
                                      color: "rgb(255,179,0)",
                                      icon: ""
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.editarHorarioEspecial(
                                          props.item
                                        )
                                      }
                                    },
                                    slot: "activator"
                                  },
                                  [_c("v-icon", [_vm._v("edit")])],
                                  1
                                ),
                                _vm._v(" "),
                                _c("span", [_vm._v("Editar fechas")])
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-tooltip",
                              { attrs: { bottom: "" } },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      slot: "activator",
                                      color: "indigo",
                                      dark: "",
                                      icon: ""
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.verDetalleHorarioEspecial(
                                          props.item
                                        )
                                      }
                                    },
                                    slot: "activator"
                                  },
                                  [_c("v-icon", [_vm._v("visibility")])],
                                  1
                                ),
                                _vm._v(" "),
                                _c("span", [_vm._v("Ver detalle")])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  nativeOn: {
                    click: function($event) {
                      return _vm.close()
                    }
                  }
                },
                [
                  _c("v-icon", [_vm._v("cancel")]),
                  _vm._v(" " + _vm._s(_vm.$t("common.cancel")) + "\n      ")
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { width: "600" },
          model: {
            value: _vm.dialog_detalle,
            callback: function($$v) {
              _vm.dialog_detalle = $$v
            },
            expression: "dialog_detalle"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "headline" },
                [
                  _c("v-icon", [_vm._v("event_note")]),
                  _vm._v("\n        Detalle de horario\n        "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "" },
                      on: {
                        click: function($event) {
                          return _vm.closeDialogDetalle()
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("clear")])],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-layout",
                    { attrs: { row: "", wrap: "" } },
                    [
                      _c(
                        "v-flex",
                        { staticClass: "text-xs-center", attrs: { xs4: "" } },
                        [
                          _c("b", [_vm._v("Horario especial: ")]),
                          _vm._v(_vm._s(_vm.form.descripcion))
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { staticClass: "text-xs-center", attrs: { xs4: "" } },
                        [
                          _c("b", [_vm._v("Fecha desde: ")]),
                          _vm._v(_vm._s(_vm.form.fecha_desde))
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { staticClass: "text-xs-center", attrs: { xs4: "" } },
                        [
                          _c("b", [_vm._v("Fecha hasta: ")]),
                          _vm._v(_vm._s(_vm.form.fecha_hasta))
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { xs12: "" } },
                        [
                          _c("v-data-table", {
                            staticClass: "elevation-1",
                            attrs: {
                              headers: _vm.headers_detalle_horario,
                              items: _vm.lista_horarios_detalle,
                              "disable-initial-sort": true
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "items",
                                fn: function(props) {
                                  return [
                                    _c(
                                      "td",
                                      { staticClass: "text-xs-center" },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(props.item.dia) +
                                            "\n                "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticClass: "text-xs-center" },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(props.item.hora_entrada) +
                                            "\n                "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticClass: "text-xs-center" },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(props.item.hora_salida) +
                                            "\n                "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("td", { staticClass: "text-xs-center" })
                                  ]
                                }
                              }
                            ])
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-18f2271b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18f2271b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/asignacion_horario/dialogs/VerHorarioEspecial.vue
// module id = null
// module chunks = 